var React = require('react');

function TrainingPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"training-path","fill":"none","stroke":"rgb(250,250,240)","strokeWidth":"2","d":"M.39,670.61C254.29,564.63,300.18,276.46,660.7,185c70.53-17.89,153.11-28.26,251.65-28.26,231.28,0,370.57-66.19,453.1-156"}));
}

TrainingPath.defaultProps = {"viewBox":"0 0 1366.19 671.53"};

module.exports = TrainingPath;

TrainingPath.default = TrainingPath;
